/* MERRY VELA — theme.js (no dependencies) */
(() => {
  'use strict';

  const theme = window.theme || { routes: {}, cartType: 'drawer' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = () => (reducedMotion ? 'auto' : 'smooth');
  const ICONS = {
    left: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5"/></svg>',
    right: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 5.5L16 12l-6.5 6.5"/></svg>'
  };

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    const fmt = String(format || theme.moneyFormat || '£{{amount}}').replace(/<[^>]*>/g, '');
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const delimit = (n, precision, thousands = ',', decimal = '.') => {
      const parts = (Number(n) / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (parts[1] ? decimal + parts[1] : '');
    };
    const m = fmt.match(re);
    if (!m) return fmt;
    const map = {
      amount: () => delimit(cents, 2),
      amount_no_decimals: () => delimit(cents, 0),
      amount_with_comma_separator: () => delimit(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => delimit(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => delimit(cents, 2, "'", '.'),
      amount_with_space_separator: () => delimit(cents, 2, ' ', ',')
    };
    return fmt.replace(re, (map[m[1]] || map.amount)());
  }

  /* ---------------- Drawers ---------------- */
  const Drawer = {
    active: null,
    lastFocus: null,
    open(id, trigger) {
      const el = document.getElementById(id);
      if (!el) return;
      if (this.active && this.active !== el) this.close(true);
      this.lastFocus = trigger || document.activeElement;
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => el.classList.add('is-open'));
      document.body.classList.add('is-locked');
      $$(`[aria-controls="${id}"][aria-expanded]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      this.active = el;
      const panel = $('.drawer__panel', el) || el;
      const target = $('[data-autofocus]', panel) || $('button, a[href], input', panel);
      setTimeout(() => target && target.focus({ preventScroll: true }), 80);
    },
    close(silent) {
      const el = this.active;
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('inert', '');
      document.body.classList.remove('is-locked');
      $$(`[aria-controls="${el.id}"][aria-expanded]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      this.active = null;
      if (!silent && this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus({ preventScroll: true });
    },
    trap(e) {
      if (!this.active || e.key !== 'Tab') return;
      const panel = $('.drawer__panel', this.active);
      const items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', panel)
        .filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  /* ---------------- Cart ---------------- */
  const Cart = {
    sectionId: 'cart-drawer',
    drawer() { return document.getElementById('CartDrawer'); },
    updateCount(count) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
    },
    render(sections, allowRefresh = true) {
      const html = sections && sections[this.sectionId];
      if (!html) { if (allowRefresh) this.refresh(); return; }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-root]', doc);
      const current = $('#CartDrawer [data-cart-root]');
      if (fresh && current) current.replaceWith(fresh);
      const source = fresh && $('[data-cart-count-source]', fresh);
      if (source) this.updateCount(parseInt(source.textContent, 10) || 0);
    },
    async refresh() {
      try {
        const res = await fetch(`${window.location.pathname}?sections=${this.sectionId}`);
        this.render(await res.json(), false);
      } catch (err) { /* keep existing drawer */ }
    },
    async add(form, submitter) {
      const errorEl = $('[data-form-error]', form);
      const scope = form.closest('[data-product-section]') || form;
      const buttons = submitter ? [submitter] : $$('button[type="submit"]', form);
      if (scope !== form) $$('[data-add-button], [data-add-button-sticky]', scope).forEach((b) => !buttons.includes(b) && buttons.push(b));
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      buttons.forEach((b) => b.classList.add('is-loading'));

      const body = new FormData(form);
      body.append('sections', this.sectionId);
      body.append('sections_url', window.location.pathname);
      try {
        const res = await fetch(`${theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        this.render(data.sections);
        buttons.forEach((b) => {
          b.classList.add('is-added');
          setTimeout(() => b.classList.remove('is-added'), 1600);
        });
        document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
        Drawer.open('CartDrawer', submitter || buttons[0]);
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      } finally {
        buttons.forEach((b) => b.classList.remove('is-loading'));
      }
    },
    async change(key, quantity) {
      const root = $('#CartDrawer [data-cart-root]');
      if (root) root.classList.add('is-updating');
      try {
        const res = await fetch(`${theme.routes.cartChange}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionId, sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'We could not update your cart.');
        this.render(data.sections);
        const close = $('#CartDrawer .drawer__header [data-drawer-close]');
        if (close) close.focus({ preventScroll: true });
      } catch (err) {
        if (root) {
          root.classList.remove('is-updating');
          let msg = $('.form-error', root);
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'form-error';
            msg.setAttribute('role', 'alert');
            $('.cart-drawer__body', root).prepend(msg);
          }
          msg.textContent = err.message;
        }
      }
    }
  };

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    if (!track || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = $$('[data-gallery-slide]', track);
    const thumbs = $$('[data-gallery-thumb]', root);
    const thumbList = $('[data-gallery-thumbs]', root);
    const counter = $('[data-gallery-counter]', root);
    const prev = $('[data-gallery-prev]', root);
    const next = $('[data-gallery-next]', root);
    let index = 0;

    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      const active = thumbs[i];
      if (active && thumbList) {
        thumbList.scrollTo({ left: active.offsetLeft - thumbList.clientWidth / 2 + active.clientWidth / 2, behavior: behavior() });
      }
      if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      slides.forEach((s, n) => {
        const v = $('video', s);
        if (v && n !== i && !v.paused) v.pause();
      });
    };
    const goTo = (i, smooth = true) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      if (!slides[target]) return;
      track.scrollTo({ left: slides[target].offsetLeft, behavior: smooth ? behavior() : 'auto' });
      setActive(target);
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && slides[i]) setActive(i);
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach((t, n) => t.addEventListener('click', () => goTo(n)));
    if (prev) prev.addEventListener('click', () => goTo(index - 1));
    if (next) next.addEventListener('click', () => goTo(index + 1));

    if (root.dataset.hoverZoom === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      $$('[data-zoom]', root).forEach((btn) => {
        btn.addEventListener('mouseenter', () => btn.classList.add('is-zooming'));
        btn.addEventListener('mouseleave', () => btn.classList.remove('is-zooming'));
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect();
          btn.style.setProperty('--zx', `${((e.clientX - r.left) / r.width) * 100}%`);
          btn.style.setProperty('--zy', `${((e.clientY - r.top) / r.height) * 100}%`);
        });
      });
    }

    root.galleryGoToMedia = (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i > -1) goTo(i);
    };

    const initial = root.dataset.initialMedia;
    const initialIndex = initial ? slides.findIndex((s) => s.dataset.mediaId === initial) : 0;
    if (initialIndex > 0) requestAnimationFrame(() => goTo(initialIndex, false));
    else setActive(0);
  }

  /* ---------------- Lightbox ---------------- */
  function initLightbox(section) {
    const lb = $('[data-lightbox]', section);
    if (!lb || lb.dataset.ready) return;
    lb.dataset.ready = 'true';
    const track = $('[data-lightbox-track]', lb);
    const slides = $$('[data-lightbox-slide]', lb);
    const closeBtn = $('[data-lightbox-close]', lb);
    let lastFocus = null;

    if (slides.length > 1) {
      [['prev', 'left', 'Previous image', -1], ['next', 'right', 'Next image', 1]].forEach(([cls, icon, label, dir]) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = `lightbox__nav lightbox__nav--${cls}`;
        b.setAttribute('aria-label', label);
        b.innerHTML = ICONS[icon];
        b.addEventListener('click', () => track.scrollBy({ left: dir * track.clientWidth, behavior: behavior() }));
        lb.appendChild(b);
      });
    }

    const open = (mediaId, trigger) => {
      let i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i < 0) i = 0;
      slides.forEach((s) => {
        const img = $('img[data-src]', s);
        if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      });
      lastFocus = trigger;
      lb.hidden = false;
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => {
        track.scrollLeft = slides[i] ? slides[i].offsetLeft : 0;
        closeBtn.focus({ preventScroll: true });
      });
    };
    const close = () => {
      lb.hidden = true;
      document.body.classList.remove('is-locked');
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };

    section.addEventListener('click', (e) => {
      const zoom = e.target.closest('[data-zoom]');
      if (!zoom) return;
      const slide = zoom.closest('[data-gallery-slide]');
      open(slide ? slide.dataset.mediaId : null, zoom);
    });
    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', (e) => { if (e.target.classList.contains('lightbox__slide')) close(); });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: behavior() });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: behavior() });
      if (e.key === 'Tab') {
        const items = $$('button', lb);
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------------- Product form ---------------- */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const jsonEl = $('[data-product-json]', section);
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent).variants || []; } catch (err) { variants = []; }
    const form = $('form.product-form', section);
    const idInput = form && $('[data-variant-id]', form);
    const fieldsets = $$('[data-option-index]', section);
    const gallery = $('[data-gallery]', section);

    const setLabel = (btn, text) => { const l = $('[data-add-label]', btn); (l || btn).textContent = text; };
    const priceHTML = (v) => {
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      return `<div class="price${sale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(v.price)}</span>${
        sale ? `<s class="price__compare"><span class="visually-hidden">Regular price</span>${formatMoney(v.compare_at_price)}</s>` : ''
      }</div>`;
    };

    const update = () => {
      const selected = fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
      fieldsets.forEach((fs, i) => {
        const label = $('[data-option-selected]', fs);
        if (label) label.textContent = selected[i] || '';
        $$('input', fs).forEach((input) => {
          const possible = variants.some((v) => v.available && v.options[i] === input.value && v.options.every((o, j) => j === i || o === selected[j]));
          const pill = input.closest('.pill');
          if (pill) pill.classList.toggle('is-unavailable', !possible);
        });
      });

      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      const buttons = $$('[data-add-button], [data-add-button-sticky]', section);
      if (!variant) {
        buttons.forEach((b) => { b.disabled = true; setLabel(b, 'Unavailable'); });
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      buttons.forEach((b) => { b.disabled = !variant.available; setLabel(b, variant.available ? 'Add to Cart' : 'Sold Out'); });
      const priceEl = $('[data-product-price]', section);
      if (priceEl) priceEl.innerHTML = priceHTML(variant);
      const sticky = $('[data-sticky-price]', section);
      if (sticky) sticky.textContent = formatMoney(variant.price);
      if (variant.featured_media && gallery && gallery.galleryGoToMedia) gallery.galleryGoToMedia(variant.featured_media.id);
      if (!window.Shopify || !window.Shopify.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', update));
    if (fieldsets.length) update();
  }

  /* ---------------- Sticky add to cart ---------------- */
  function initStickyAtc(section) {
    const bar = $('[data-sticky-atc]', section);
    const main = $('[data-add-button]', section);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    let mainVisible = true;
    let footerVisible = false;
    const sync = () => {
      const show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    };
    new IntersectionObserver(([entry]) => { mainVisible = entry.isIntersecting; sync(); }, { rootMargin: '-80px 0px 0px 0px' }).observe(main);
    const footer = $('.footer');
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; sync(); }).observe(footer);
  }

  /* ---------------- Carousel ---------------- */
  function initCarousel(root) {
    const track = $('[data-carousel-track]', root);
    if (!track || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const items = Array.from(track.children);
    const dotsWrap = $('[data-carousel-dots]', root);
    const prev = $('[data-carousel-prev]', root);
    const next = $('[data-carousel-next]', root);
    let perPage = 1;
    let pages = 1;
    let page = 0;

    const metrics = () => {
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap) || 0;
      const padL = parseFloat(cs.paddingLeft) || 0;
      const padR = parseFloat(cs.paddingRight) || 0;
      const itemW = items[0] ? items[0].getBoundingClientRect().width : 1;
      return { gap, padL, inner: track.clientWidth - padL - padR, itemW };
    };
    const currentPage = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return 0;
      if (track.scrollLeft >= max - 4) return pages - 1;
      const { gap, itemW } = metrics();
      return Math.round(track.scrollLeft / ((itemW + gap) * perPage));
    };
    const render = () => {
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= pages - 1;
      if (!dotsWrap) return;
      if (pages <= 8) {
        $$('.carousel__dot', dotsWrap).forEach((d, i) => {
          d.classList.toggle('is-active', i === page);
          if (i === page) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      } else {
        const c = $('.carousel__count', dotsWrap);
        if (c) c.textContent = `${page + 1} / ${pages}`;
      }
    };
    const goTo = (p) => {
      page = Math.max(0, Math.min(pages - 1, p));
      const target = items[page * perPage];
      if (target) track.scrollTo({ left: target.offsetLeft - metrics().padL, behavior: behavior() });
      render();
    };
    const measure = () => {
      if (!items.length) return;
      const { gap, inner, itemW } = metrics();
      perPage = Math.max(1, Math.round((inner + gap) / (itemW + gap)));
      pages = Math.max(1, Math.ceil(items.length / perPage));
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        if (pages <= 8) {
          for (let i = 0; i < pages; i += 1) {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'carousel__dot';
            d.setAttribute('aria-label', `Show reviews page ${i + 1}`);
            d.addEventListener('click', () => goTo(i));
            dotsWrap.appendChild(d);
          }
        } else {
          const c = document.createElement('span');
          c.className = 'carousel__count';
          dotsWrap.appendChild(c);
        }
      }
      page = currentPage();
      render();
    };

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { page = currentPage(); render(); ticking = false; });
    }, { passive: true });
    if (prev) prev.addEventListener('click', () => goTo(page - 1));
    if (next) next.addEventListener('click', () => goTo(page + 1));

    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) track.classList.add('is-dragging');
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!dragging) return;
      dragging = false;
      if (track.classList.contains('is-dragging')) {
        track.classList.remove('is-dragging');
        goTo(currentPage());
      }
    });

    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);
    else window.addEventListener('resize', measure);
    measure();
  }

  /* ---------------- Delivery estimate ---------------- */
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach((el) => {
      const n = (k) => parseInt(el.dataset[k], 10) || 0;
      const addWorkingDays = (days) => {
        const d = new Date();
        let added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
        }
        return d;
      };
      const fmt = (d) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      const range = (a, b) => (a.toDateString() === b.toDateString() ? fmt(a) : `${fmt(a)} – ${fmt(b)}`);
      const dispatch = $('[data-date="dispatch"]', el);
      const delivery = $('[data-date="delivery"]', el);
      if (dispatch) dispatch.textContent = range(addWorkingDays(n('dispatchMin')), addWorkingDays(n('dispatchMax')));
      if (delivery) delivery.textContent = range(addWorkingDays(n('dispatchMin') + n('deliveryMin')), addWorkingDays(n('dispatchMax') + n('deliveryMax')));
    });
  }

  /* ---------------- Reveal ---------------- */
  let revealObserver = null;
  function initReveal(root) {
    const els = $$('[data-reveal]:not(.is-revealed)', root);
    const skip = reducedMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode);
    if (skip) { els.forEach((e) => e.classList.add('is-revealed')); return; }
    const vh = window.innerHeight;
    els.forEach((e) => { if (e.getBoundingClientRect().top < vh * 0.92) e.classList.add('is-revealed'); });
    document.documentElement.classList.add('reveal-ready');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealObserver.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    els.filter((e) => !e.classList.contains('is-revealed')).forEach((e) => revealObserver.observe(e));
  }

  /* ---------------- Init ---------------- */
  function initAll(root = document) {
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product-section]', root).forEach((s) => { initProduct(s); initLightbox(s); initStickyAtc(s); });
    $$('[data-carousel]', root).forEach(initCarousel);
    initDelivery(root);
    initReveal(root);
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); Drawer.open(opener.dataset.drawerOpen, opener); return; }

    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Drawer.close(); return; }

    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && theme.cartType === 'drawer' && Cart.drawer()) { e.preventDefault(); Drawer.open('CartDrawer', cartLink); return; }

    const productSubmit = e.target.closest('[data-product-submit]');
    if (productSubmit) {
      e.preventDefault();
      const form = $('form.product-form');
      const mainBtn = form && $('[data-add-button]', form);
      if (!form || !mainBtn || mainBtn.disabled) {
        const top = $('#MainContent');
        if (top) top.scrollIntoView({ behavior: behavior() });
        return;
      }
      if (theme.cartType === 'drawer' && Cart.drawer() && window.fetch) Cart.add(form, productSubmit);
      else mainBtn.click();
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { e.preventDefault(); Cart.change(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.cartQty, 10) || 0); return; }

    const stepBtn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (stepBtn) {
      const input = $('input', stepBtn.closest('[data-qty]'));
      if (!input) return;
      const min = parseInt(input.min, 10) || 1;
      const value = parseInt(input.value, 10) || min;
      input.value = Math.max(min, value + (stepBtn.hasAttribute('data-qty-plus') ? 1 : -1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.js-ajax-cart');
    if (!form || theme.cartType !== 'drawer' || !Cart.drawer() || !window.fetch) return;
    e.preventDefault();
    Cart.add(form, e.submitter && e.submitter.closest('button') ? e.submitter : null);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-auto]');
    if (!input) return;
    const form = input.form;
    const btn = form && $('[name="update"]', form);
    if (form) { if (form.requestSubmit && btn) form.requestSubmit(btn); else if (btn) btn.click(); else form.submit(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && Drawer.active) Drawer.close();
    Drawer.trap(e);
  });

  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', () => { if (Drawer.active) Drawer.close(true); });
  document.addEventListener('shopify:block:select', (e) => {
    const track = e.target.closest('[data-carousel-track], .gifts--image');
    if (track) track.scrollTo({ left: e.target.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: behavior() });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  window.MerryVela = { formatMoney, Cart, Drawer };
})();
